import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useCallback, Fragment } from "react";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
import FloatingLabelWrapper from "../floating-label-wrapper/floating-label-wrapper";
function TextInputFloatingLabel(props) {
    const { inputData, errorState, invalid, errorLabelId, id, defaultValue, translate } = props;
    const { inputName, type, isRequired, placeholder } = inputData;
    const { isValid } = errorState;
    const [isFocused, setIsFocused] = useState(false);
    const [hasValue, setHasValue] = useState(!!defaultValue);
    const handleFocus = useCallback(()=>{
        setIsFocused(true);
    }, []);
    const handleBlur = useCallback((e)=>{
        const { onInputBlur } = props;
        setIsFocused(false);
        setHasValue(!!e.target.value);
        if (onInputBlur) {
            onInputBlur(e);
        }
    }, [
        props
    ]);
    const handleChange = useCallback((e)=>{
        const { onInputChange } = props;
        setHasValue(!!e.target.value);
        if (onInputChange) {
            onInputChange(e);
        }
    }, [
        props
    ]);
    const showRequiredError = !isValid && isRequired;
    const requiredClass = {
        "input-required": showRequiredError
    };
    const translatedPlaceholder = translate(placeholder);
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FloatingLabelWrapper, {
                label: translatedPlaceholder,
                htmlFor: id,
                isFocused: isFocused,
                hasValue: hasValue,
                children: /*#__PURE__*/ _jsx("input", {
                    id: id,
                    onChange: handleChange,
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    name: inputName,
                    type: type,
                    "aria-label": translatedPlaceholder,
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    defaultValue: defaultValue,
                    className: `jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-text-input", requiredClass) || "")
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            })
        ]
    });
}
TextInputFloatingLabel.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(TextInputFloatingLabel);
